export default __webpack_public_path__ + "static/media/Previous.71b6d80f.svg";